






























import { ListType, EnumType } from 'expangine-runtime';
import { ListOptions } from '../../../common';
import { TypeSettings } from '../TypeVisuals';
import { ListEnumCheckboxOptions } from './ListEnumCheckboxTypes';
import { ListSubs } from './ListTypes';
import TypeInputBase from '../TypeInputBase';


const MIN_INPUT_WIDTH = 1000;
const GRID_COLUMNS = 12;

export default TypeInputBase<ListType, ListEnumCheckboxOptions, any[], ListSubs>(Array).extend({
  name: 'ListEnumCheckbox',
  data: () => ({
    width: 1,
  }),
  computed: {
    themeClass(): string {
      return this.settings.options.dark
        ? 'theme--dark'
        : 'theme--light';
    },
    enumType(): EnumType {
      return this.type.options.item as EnumType;
    },
    entries(): Array<[any, any]> {
      return Array.from(this.enumType.options.constants.entries());
    },
    minWidth(): number {
      return this.settings.options.minWidth || MIN_INPUT_WIDTH;
    },
    columns(): number {
      return Math.floor(this.minWidth / this.width * GRID_COLUMNS);
    },
  },
  methods: {
    updateWidth() {
      const el = this.$refs.parent as HTMLElement;
      this.width = el.offsetWidth;
    },
  },
});
